'use client';

import { Avatar } from '@/components';
import { Popover, PopoverContent, PopoverTrigger } from '@nextui-org/react';
import { signOut, useSession } from 'next-auth/react';
import { useState } from 'react';

import { ROUTES } from '@/constaint/route';
import { logoutApi } from '@/services/api/auth';
import { CaretDown, GearSix, SignOut, User } from '@phosphor-icons/react';
import classNames from 'classnames';
import { usePathname, useRouter } from 'next/navigation';
import AccountSettingModal from '@/components/AccountSettingModal';
import { CurrencyDollar } from 'phosphor-react';

const MenuUserRecruiter = () => {
  const { data: session } = useSession();
  const router = useRouter();
  const pathname = usePathname();
  const [isOpen, setIsOpen] = useState(false);
  const [isAccountSettingModalOpen, setIsAccountSettingModalOpen] = useState(false);
// console.log("SSSSSSSSS", session?.user?.user?.avatar)
  const openRecruiterBase = () => {
    setIsOpen(false);
    router.push(ROUTES.RECRUITER.MY_CANDIDATE);
  };

  const openRecruiterPayment = () => {
    setIsOpen(false);
    router.push(ROUTES.RECRUITER.MY_PAYMENT);
  };

  const handleLogout = async () => {
    setIsOpen(false);
    
    try {
      // Gọi API logout nếu cần
      await logoutApi();
    } catch (error) {
      console.error(error);
    }
    
    // Xóa tất cả localStorage
    localStorage.clear();
    
    // Xóa tất cả cookie bằng cách đặt thời gian hết hạn về quá khứ
    document.cookie.split(";").forEach(function(c) {
      document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });
    
    // Đảm bảo xóa cookie cụ thể
    document.cookie = "next-auth.session-token=;expires=" + new Date().toUTCString() + ";path=/";
    document.cookie = "next-auth.callback-url=;expires=" + new Date().toUTCString() + ";path=/";
    document.cookie = "next-auth.csrf-token=;expires=" + new Date().toUTCString() + ";path=/";
    
    // Đăng xuất từ NextAuth
    await signOut({ redirect: false });
    
    // Chuyển hướng
    window.location.href = ROUTES.HOME;
  };

  const openAccountSetting = () => {
    setIsOpen(false);
    setIsAccountSettingModalOpen(true);
  };

  return (
    <>
      <Popover placement='bottom-end' isOpen={isOpen} onOpenChange={setIsOpen}>
        <PopoverTrigger>
          <div className='flex items-center gap-2 cursor-pointer'>
            <Avatar src={session?.user?.user?.avatar || ''} size='sm' />
            <CaretDown size={20} />
          </div>
        </PopoverTrigger>
        <PopoverContent className='min-w-[180px] bg-white p-2 rounded-2xl border border-[#19052f0d] shadow-sm'>
          <div
            className={classNames(
              'w-full text-primary font-medium cursor-pointer flex items-center gap-3 px-4 py-3 rounded-lg hover:bg-[#cccccc1f]',
              pathname === ROUTES.RECRUITER.MY_CANDIDATE && 'bg-[#cccccc1f]',
            )}
            onClick={openRecruiterBase}
          >
            <User size={20} />
            <span className=''>My candidates</span>
          </div>
          <div
            className={classNames(
              'w-full text-primary font-medium cursor-pointer flex items-center gap-3 px-4 py-3 rounded-lg hover:bg-[#cccccc1f]',
              pathname === ROUTES.RECRUITER.MY_PAYMENT && 'bg-[#cccccc1f]',
            )}
            onClick={openRecruiterPayment}
          >
            <CurrencyDollar size={20} />
            <span className=''>My payment</span>
          </div>
          <div
            className='w-full text-primary font-medium cursor-pointer flex items-center gap-3 px-4 py-3 rounded-lg hover:bg-[#cccccc1f]'
            onClick={openAccountSetting}
          >
            <GearSix size={20} />
            <span className=''>Account Setting</span>
          </div>
          <div
            className='w-full font-medium text-text-error-primary cursor-pointer flex items-center gap-3 px-4 py-3 rounded-lg hover:bg-[#cccccc1f]'
            onClick={handleLogout}
          >
            <SignOut size={20} />
            <span className=''>Log Out</span>
          </div>
        </PopoverContent>
      </Popover>

      {isAccountSettingModalOpen && (
        <AccountSettingModal
          isOpen={isAccountSettingModalOpen}
          onClose={() => setIsAccountSettingModalOpen(false)}
        />
      )}
    </>
  );
};

export default MenuUserRecruiter;
